<script setup lang="ts">
import { ref } from 'vue'

// import { defineAsyncComponent } from 'vue';
// const PersonaHumanitas = defineAsyncComponent(() => import('./components/UnaP.vue')) ; 
const images = [
  '/pagesImages/despierta-merch.webp',
  '/pagesImages/despierta-merch-2.webp'
]

const alts = [
  'Merch 1',
  'Merch 2'
]

const currentImage = ref(0)

function nextImage() {
  currentImage.value = (currentImage.value + 1) % images.length
}
</script>

<template class="">
    <section class="flex w-full mt-[88px] lg:mt-[143px] justify-center items-center bg-cover bg-[center] bg-no-repeat"  style="background-image: url(/pagesImages/cafeteria-despierta-universidad-humanitas.jpg); position: relative; background-attachment: fixed; background-position: center; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="flex my-44 items-center justify-center mx-auto">
            <img src="/pagesImages/logotipo-despierta-gde.png" alt="Logo despierta">
        </div>
    </section>
    <div class="flex flex-col items-center justify-center w-full ">
        <div class="md:flex mt-12 w-full mb-8 max-w-4xl lg:max-w-[1200px] justify-between items-center">
            <div class="flex flex-col justify-center w-full md:w-[50%] lg:px-0 px-8">
                <h1 class="text-hgold text-[48px] mb-4 font-serif">Cafeterías Despierta</h1>
                <p class="text-justify lg:hyphens-none hyphens-auto mb-4">En Despierta, reinventamos la experiencia gastronómica universitaria. Es un espacio donde la alimentación saludable se fusiona con el auténtico sabor casero.</p>
                <p class="text-justify lg:hyphens-none hyphens-auto mb-4">Los platillos son elaborados con ingredientes naturales y de origen mexicano, seleccionados bajo los más altos estándares de higiene y calidad, apoyando así a comerciantes y agricultores locales.</p>
                <p class="text-justify lg:hyphens-none hyphens-auto mb-4">Además, en Despierta creemos en la sustentabilidad. Por ello, utilizamos empaques reciclables y compostables, reafirmando nuestro compromiso con el planeta y con un estilo de vida más consciente.</p>
                <!-- <a href="https://sites.google.com/humanitas.edu.mx/menudespierta/inicio" target="_blank">
                    <button  class="bg-white transition duration-300 ease-in-out mb-4 uppercase rounded-none border border-green-900 text-green-900 m-4 hover:bg-hgold hover:text-white">descarga nuestro men&uacute;</button>
                </a> -->
            </div>
            <div class="flex items-center justify-center">
                <img src="/pagesImages/buho-despierta.png" class="" alt="Despierta">
            </div>
            
        </div>

        <!-- <div class="flex items-center max-w-4xl lg:max-w-6xl w-full justify-center mb-12 ">
            <div class="flex items-center justify-center">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 px-4">
                    <img src="/pagesImages/alimentos-desp.jpg" alt="Alimentos Frescos y de origen natural" class="image border border-black" />
                    <img src="/pagesImages/productos-desp.jpg" alt="Productos de origen Mexicano" class="image border border-black" />
                    <img src="/pagesImages/empaq-desp.jpg" alt="Empaques reciclables y compostables" class="image border border-black" />
                </div>
            </div>
        </div> -->

        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/chapatas-cafeteria-despierta.webp" alt="Chapatas de cafetería Despierta" class="w-full lg:max-w-[520px]"/>
                        </div>
                        <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Alimentos frescos y de origen natural</span>
                            </h2>
                            <p class="mb-4">
                                Nuestros productos contienen ingredientes frescos, 100% naturales, cultivados con respeto por la tierra y las manos que los trabajan.
                            </p>
                            <p class="">
                                Buscamos llevarte alimentos sin conservantes y con todo su valor nutricional intacto. Cada bocado es un tributo a la riqueza de nuestra tierra.
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Productos de origen mexicano</span>
                            </h2>
                            <p class="mb-4">
                                Celebramos la riqueza gastronómica de nuestra tierra, por lo que nuestros insumos tienen origen en los estados de: Oaxaca, Chiapas, Tabasco y Veracruz, rescatando los sabores auténticos que han alimentado generaciones.
                            </p>
                            <p class="">
                                Nuestro menú cambia según los ciclos naturales, porque lo fresco no solo sabe mejor, sino que es más sustentable.
                            </p>
                        </div>
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/despierta-productos-mexicanos.webp" alt="Quesadillas de cafetería Despierta" class="w-full lg:max-w-[520px]"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                            <img src="/pagesImages/vasos-cafe-despierta.webp" alt="Vasos de café de Despierta" class="w-full lg:max-w-[520px]"/>
                        </div>
                        <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Empaques reciclables y compostables</span>
                            </h2>
                            <p class="mb-4">
                                En Despierta, nuestros empaques son una extensión de nuestro compromiso con la Tierra, por lo que cuentan con las siguientes características:
                            </p>
                            <ul class=" list-disc pl-8">
                                <li>100% compostables: Se convierten en abono en algunas semanas.</li>
                                <li>Hechos de materiales vegetales: Fibra de caña, maíz y hojas de plátano.</li>
                                <li>Diseñados para desaparecer: Sin rastros tóxicos ni microplásticos.</li>
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
        </section>
        <section class="flex items-center justify-center mb-16 w-full">
            <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                <div class="flex flex-col justify-between">
                    <div class="lg:flex items-center justify-center">
                        <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                            <h2>
                                <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                <span class="block text-hgold text-left font-serif mb-3 text-[32px]">Viste con estilo Humanitas</span>
                            </h2>
                            <p class="mb-4">
                                Porta con estilo y actitud Humanitas: Encuentra tu prenda favorita en las cafeterías Despierta de tu campus más cercano.
                            </p>
                            <p class="">
                                <b>Bolsa humanitas</b> - $ 250 MXN<br> 
                                <b>Gorra</b> <br>
                                Colores: blanca y verde - $ 200 MXN<br>
                                <b>Hoodie</b> <br>
                                Colores: hueso y verde - $ 800 MXN<br>
                                <b>Playera</b><br> 
                                Colores: hueso y verde - $ 300 MXN
                            </p>
                        </div>
                        <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                            <img
                            :src="images[currentImage]"
                            :alt="alts[currentImage]"
                            class="w-full lg:max-w-[520px]"
                            />
                            <button
                            @click="nextImage"
                            class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                            >
                            &gt;
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    
    <!-- <PersonaHumanitas /> -->
</template>

<style scoped>
</style>